import { TIAnnotationStore as AnnotationStore } from 'modules/Annotations/store/annotationsStore';
import { CanvasStore } from 'modules/Canvas/store/canvasStore';
import { VideoTrackTimelineStore } from './VideoTrackTimelineStore';

class RootStore {
  private static instance: RootStore;

  private videoTrackTimelineStore: VideoTrackTimelineStore;

  private annotationStore: AnnotationStore | undefined;

  private canvasStore: CanvasStore | undefined;

  private constructor(annotationStore?: AnnotationStore, canvasStore?: CanvasStore) {
    this.annotationStore = annotationStore;
    this.canvasStore = canvasStore;
    this.videoTrackTimelineStore = new VideoTrackTimelineStore();
  }

  public static getInstance(annotationStore?: AnnotationStore, canvasStore?: CanvasStore) {
    if (!RootStore.instance) {
      RootStore.instance = new RootStore(annotationStore, canvasStore);
    }

    if (!RootStore.instance.getAnnotationStore() && annotationStore) {
      RootStore.instance.setAnnotationStore(annotationStore);
    }

    if (!RootStore.instance.getCanvasStore() && canvasStore) {
      RootStore.instance.setCanvasStore(canvasStore);
    }

    return RootStore.instance;
  }

  public getAnnotationStore() {
    return this.annotationStore;
  }

  public getCanvasStore() {
    return this.canvasStore;
  }

  public getVideoTrackTimelineStore() {
    return this.videoTrackTimelineStore;
  }

  public setAnnotationStore(annotationStore: AnnotationStore) {
    this.annotationStore = annotationStore;
  }

  public setCanvasStore(canvasStore: CanvasStore) {
    this.canvasStore = canvasStore;
  }
}

export { RootStore };
